import * as React from 'react';

import type { AllPermissionKeys } from '~/modules/settings/_generated/permissions';
import { usePermission } from '~/shared/hooks/usePermission';

interface PermissionGateProps {
  action: AllPermissionKeys;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  loading?: React.ReactNode;
  errorFallback?: React.ReactNode;
  mode?: 'hide' | 'disable';
}

export function PermissionGate({
  action,
  children,
  fallback = null,
  loading,
  errorFallback,
  mode = 'hide',
}: PermissionGateProps) {
  const { allowed, isLoading, isError } = usePermission(action);

  if (isLoading && loading !== undefined) {
    return loading;
  }

  if (isError && errorFallback !== undefined) {
    return errorFallback;
  }

  if (!allowed) {
    if (mode === 'disable') {
      return (
        <div inert className="contents opacity-50">
          {children}
        </div>
      );
    }
    return fallback;
  }

  return children;
}
